import apiClient from "../api/apiClient";

class ErrorHandler {
  static _customErrorCallback = null;

  static setErrorCallback(callback) {
    this._customErrorCallback = callback;
  }
  static init() {
    // Global error listeners
    window.addEventListener("error", (event) => {
      this.logError({
        type: "Global Error",
        error: event.error,
        stack: event.error?.stack,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      });
    });

    window.addEventListener("unhandledrejection", (event) => {
      this.logError({
        type: "Unhandled Rejection",
        error: event.reason,
        stack: event.reason?.stack,
      });
    });
  }

  static logError(errorData) {
    const errorPayload = {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      ...errorData,
    };

    if (typeof this._customErrorCallback === "function") {
      this._customErrorCallback(errorPayload); // 🔧 call user-defined callback
    }

    this.sendToBackend(errorPayload);

    if (process.env.NODE_ENV === "development") {
      console.error("Logged error:", errorPayload);
    }
  }

  static logComponentError(error, errorInfo) {
    this.logError({
      type: "React Error",
      error: error.toString(),
      stack: errorInfo?.componentStack,
    });
  }

  static logApiError(error) {
    const errorData = {
      type: "API Error",
      error: error.message,
      stack: error.stack,
      status: error.status,
      url: error.url,
      responseData: error.data,
    };

    this.logError(errorData);
    return errorData;
  }

  static async sendToBackend(errorData) {
    try {
      // await apiClient(`/ErrorLogging`, {
      //   method: "POST",
      //   body: errorData,
      // });
    } catch (err) {
      console.log("Error logging failed:", err);
      console.log("Original error:", errorData);
    }
  }
}

export default ErrorHandler;
